<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12 component-title-row">
          <h3><i class="fa fa-fw fa-tag"></i> {{ _('Discount codes') }}</h3>
          <div class="component-title-buttons">
            <button class="newSelector btn btn-success addbutton" type="button" v-on:click.stop="createNewDialog"><i class="fa fa-fw fa-plus"></i><span class="hidden-xs"> {{ _('Create new...') }}</span></button>
          </div>
        </div>
      </div>
      <div class="list-filter-row form-group">
        <div class="list-filter-col filtercol">
          <div class="form-group">
            <div class="input-group">
              <input class="form-control" id="searchField" type="text" v-model="search" :placeholder="_('Keyword search')" />
              <span class="input-group-btn">
                <button type="button" class="btn btn-success"><i class="fa fa-fw fa-search"></i></button>
              </span>
            </div>
          </div>
        </div>
        <div class="list-filter-col filtercol">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-addon">{{ _('Display') }}</div>
              <select class="form-control" id="discountTypeFilter" v-model="type">
                <option value="all">{{ _('All discount codes') }}</option>
                <option value="orderlevel">{{ _('Order-level codes') }}</option>
                <option value="productlevel">{{ _('Product-level codes') }}</option>
                <option value="percent">{{ _('Percentage value codes') }}</option>
                <option value="eur">{{ _('Fixed value codes') }}</option>
                <option value="permanent">{{ _('Permanent codes') }}</option>
                <option value="singleuse">{{ _('Single use codes') }}</option>
                <option value="multiuse">{{ _('Multi use codes') }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <Datatable :url="discountsUrl" :search="search" :type-filter="type" :options="tableOptions" ref="datatable" v-on:data="tableEvent" />
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import Datatable from '~/components/Datatable'
import debounce from 'lodash/debounce'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      discounts: [],
      search: '',
      type: 'all',
      tableOptions: {
        responsiveLayoutCollapseFormatter: $this.collapseFormatter(),
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 60,
          responsive: 0
        },
        {
          title: _('Code'),
          field: 'code',
          widthGrow: 4,
          responsive: 0
        },
        {
          title: _('Type'),
          field: 'type',
          widthGrow: 4,
          formatter: $this.discountTypeFormatter()
        },
        {
          title: _('Discount'),
          field: 'amount',
          widthGrow: 1,
          hozAlign: 'right'
        },
        {
          title: _('Unit'),
          field: 'unit',
          widthGrow: 1,
          formatter: $this.discountUnitFormatter()
        },
        {
          title: _('Usage'),
          field: 'usage',
          widthGrow: 2,
          formatter: $this.discountUsageFormatter()
        },
        ],
        initialSort: [{
          column: 'id',
          dir: 'asc'
        }],
        rowClick (e, row) {
          $this.editRow(row)
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    discountsUrl () {
      return this.baseDomain + this.shopId + '/discounts.json?apikey=' + this.apiKey
    }
  },
  methods: {
    editRow (row) {
      let id = row.getCell('id').getValue()
      let code = row.getCell('code').getValue()
      this.editDiscount(id, code)
    },
    editDiscount (id, code, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'DiscountDetails',
        title: this._('Discount') + ' ' + id + (code ? ': ' + code : ''),
        width: 6,
        data: {
          discountId: id
        },
        skipState
      })
    },
    createNewDialog () {
      this.showDialog({
        title: this._('Create new...'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'save',
            requiredFields: ['code'],
            handler: this.createNew
          }
        ],
        fields: [
          {
            title: this._('Code'),
            type: 'text',
            name: 'code'
          }
        ]
      })
    },
    async createNew (data) {
      let response
      let d = {
        code: data.code,
        amount: 0,
        unit: 0,
        type: 0,
        usage: 0,
        valid_ts: null
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/discounts.json?apikey=' + this.apiKey, d)
        if (response.data) {
          this.editDiscount(response.data, data.code)
        }
      } catch(e) {
        this.showError(e)
      }
    },
    reload () {
      this.$refs.datatable.reload()
    }
  },
  components: {
    Datatable
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['discountUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      events['restoreDetails'] = (message) => {
        if (message.shopId !== this.shopId) {
          return
        }
        switch(message.component) {
          case 'DiscountDetails':
            this.editDiscount(message.data.discountId, null, true)
            break
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>